/*
 * View for embedded Tableau reports
 */
define([
  "jquery",
  "marionette",
  "modules/reportSplit/adHoc/template/adHocReportTemplate.html",
], function ($, Marionette, AdHocReportTemplate) {
  "use strict";

  const AdHocReportView = {};

  AdHocReportView.adHocReportLayout = Marionette.Layout.extend({
    template: AdHocReportTemplate,
    className: "row-fluid max-height",
    loadAdHocReport: function (url) {
      const el = $("#adHocReportFrame");
      if (el.length) {
        el[0].contentWindow.location.href = url;
      }
    },
  });

  return AdHocReportView;
});
